import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles({
  summaryWrapper: {
    marginTop: '20px',
    display: 'inline-flex',
    alignItems: 'stretch',
    flexWrap: 'wrap',
    justifyContent: 'flex-end'
  },
  infoContainer: {
    alignItems: 'center',
    width: '100%',
    padding: '14px 32px',
    [breakpointsFunc.breakpoints.down('lg')]: {
      width: '100%'
    },
    [breakpointsFunc.breakpoints.down('md')]: {
      alignItems: 'flex-start'
    },
    [breakpointsFunc.breakpoints.down('md')]: {
      width: '100%',
      alignItems: 'flex-start'
    }
  },
  info: {
    '& .MuiTypography-root': {
      whiteSpace: 'nowrap'
    },
    [breakpointsFunc.breakpoints.down('md')]: {
      paddingTop: '10px',
      flexGrow: '1'
    }
  },
  summaryCell: {
    paddingRight: '14px',
    paddingLeft: '14px'
  }
});
export default useStyles;